import { Stack } from '@mui/material';
import { useTheme } from '@mui/system';
import { type GridSlotProps } from '@mui/x-data-grid';
import { FC } from 'react';

import { useTranslations } from '../../../hooks/use-translations';

type TableNoRowsOverlayProps = GridSlotProps['noRowsOverlay'] & {
  noRowText?: string;
};

export const TableNoRowsOverlay: FC<TableNoRowsOverlayProps> = ({ noRowText }) => {
  const theme = useTheme();
  const t = useTranslations('table');

  return (
    <Stack height="100%" alignItems="center" justifyContent="center" color={theme.palette.text.noTableData}>
      {noRowText ?? t('No records found for given search criteria')}
    </Stack>
  );
};
